import { useMemo, useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip, Card, Col, Row, Button, Nav, Tab } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { postCommonMaster, postActivity, postActivitySave, getActivityDetails, deleteActivity } from '../../apiservices/ApiServices';

const Activity = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [data, setData] = useState([]);
    const [commonMaster, setCommonMaster] = useState([]);
    const [isEdit, setIsEdit] = useState(false);

    const postActivitys = async (postData) => {
        setLoading(true);
        try {
            const res = await postActivity(postData);
            setData(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            search: "",
            filters: {
                document_title: ""
            },
            page: 1,
            length: 100
        }
        try {
            const res = await postActivity(postData);
            setData(res.data.data);
        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            search: "",
            filters: {
                document_title: ""
            },
            page: 1,
            length: 100
        }
        postActivitys(postData);
    }, []);

    const emptyStatement = {
        activityId: '',
        activityName: '',
        activityDisplayOrder: '',
        activityIsSub: 1,
        activityunit: '',
        activityunitValue: '',
        activitychecklist: [],
        activityoutputTemplateId: [],
        clientCentricIds: [],
        billingEntityCentricIds: [],
        activityIsMandatory: 0,
        activitySubId: '',
        subActivity: {
            id: '',
            name: '',
            displayOrder: '',
            unit: '',
            unitValue: '',
            checklist: [],
            outputTemplateId: [],
            clientRoleBy: [],
            billingRoleBy: [],
            isMandatory: 0
        }
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        subActivity: [emptyStatement]
    });

    const add = () => {
        const newIndex = values.subActivity.length;
        setFieldValue('subActivity', [...values.subActivity, { ...emptyStatement }]);
    };

    const remove = (index) => {
        const updated = values.subActivity.filter((_, i) => i !== index);
        setFieldValue('subActivity', updated);
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            let postData;

            if (values.activityIsSub == 0) {

                postData = {
                    activity_id: values?.activityId || '',
                    activity_name: values.activityName || '',
                    display_order: values.activityDisplayOrder || '',
                    is_sub_activity: 0,
                    sub_activity: [
                        {
                            sub_activity_id: values.activitySubId || '',
                            sub_activity_name: values.activityName || '',
                            display_order: values.activityDisplayOrder || '',
                            estimated_completion_unit: values.activityunit,
                            estimated_completion_value: values?.activityunitValue,
                            activity_purpose_ids: values?.activitychecklist,
                            client_centric_ids: values?.clientCentricIds,
                            billing_entity_centric_ids: values?.billingEntityCentricIds,
                            email_template_ids: values?.activityoutputTemplateId,
                            is_mandatory: values?.activityIsMandatory
                        }
                    ]
                };
            }
            else {
                postData = {
                    activity_id: values?.activityId || '',
                    activity_name: values.activityName || '',
                    display_order: values.activityDisplayOrder || '',
                    is_sub_activity: 1,
                    sub_activity: values.subActivity.map((item, idx) => ({
                        sub_activity_id: item?.id,
                        sub_activity_name: item?.name,
                        display_order: item?.displayOrder,
                        estimated_completion_unit: item?.unit,
                        estimated_completion_value: item?.unitValue,
                        activity_purpose_ids: item?.checklist,
                        email_template_ids: item?.outputTemplateId,
                        is_mandatory: item?.isMandatory,
                        client_centric_ids: item?.clientRoleBy,
                        billing_entity_centric_ids: item?.billingRoleBy,
                        dependent_sub_activity_id: idx + 1

                    })),
                };
            }

            try {
                const res = await postActivitySave(postData);
                toast.success(res.data.message);
                postUpdates();
                setLoadings(false);
                setAddModal(false);
                formik.resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        setIsEdit(false);
        let postData = {
            type: [
                "email_template",
                "activity_purpose",
                "client_centric",
                "billing_entity_centric"
            ],
            org_type_code: ''
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);
            setLoadings(false);
            setAddModal(true);
            setFieldValue('activityIsSub', 1);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        formik.resetForm();
    };

    const handleEdit = async (activity) => {
        setLoadings(true);
        let postData = {
            type: [
                "email_template",
                "activity_purpose",
                "client_centric",
                "billing_entity_centric"
            ],
            org_type_code: ''
        };
        try {
            const resp = await postCommonMaster(postData);
            setCommonMaster(resp.data.data);

            const res = await getActivityDetails(activity?.activity_id);
            const data = res.data?.data;

            // Set top-level activity fields
            setFieldValue('activityId', data?.activity_id);
            setFieldValue('activityName', data?.activity_name);
            setFieldValue('activityDisplayOrder', data?.display_order);

            if (data?.is_sub_activity) {
                const subActivities = (data.sub_activity || []).map((sub) => ({
                    id: sub.sub_activity_id,
                    name: sub.sub_activity_name || '',
                    displayOrder: sub.display_order || '',
                    unit: sub.estimated_completion_unit || '',
                    unitValue: sub.estimated_completion_value || '',
                    checklist: sub.activity_purpose_ids || [],
                    outputTemplateId: sub.email_template_ids || [],
                    clientRoleBy: sub.client_centric_ids || [],
                    billingRoleBy: sub.billing_entity_centric_ids || [],
                    isMandatory: sub.is_mandatory ? 1 : 0
                }));
                setFieldValue('activityIsSub', 1);
                setFieldValue('subActivity', subActivities);
                setIsEdit(true);
                setLoadings(false);
                setAddModal(true);
            } else {
                setFieldValue('activityIsSub', 0);
                setFieldValue('activitySubId', data?.sub_activity?.[0]?.sub_activity_id);
                setFieldValue('activityunit', data?.sub_activity?.[0]?.estimated_completion_unit);
                setFieldValue('activityunitValue', data?.sub_activity?.[0]?.estimated_completion_value);
                setFieldValue('activitychecklist', data?.sub_activity?.[0]?.activity_purpose_ids);
                setFieldValue('activityoutputTemplateId', data?.sub_activity?.[0]?.email_template_ids);
                setFieldValue('clientCentricIds', data?.sub_activity?.[0]?.client_centric_ids);
                setFieldValue('billingEntityCentricIds', data?.sub_activity?.[0]?.billing_entity_centric_ids);
                setFieldValue('activityIsMandatory', 0);
                setIsEdit(true);
                setLoadings(false);
                setAddModal(true);
            }
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = (activity) => {
        setShow(true);
        setFieldValue('activityId', activity?.activity_id);
        setFieldValue('activityName', activity?.activity_name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteActivity(values.activityId);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdates();
            setFieldValue('activityId', '');
            setFieldValue('activityName', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Activity" active="Activity" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Activity</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="table-responsive" style={{ marginTop: 50 }}>
                                        <table className="table table-bordered text-nowrap mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Display Order</th>
                                                    <th>Activity</th>
                                                    <th>sub Activity</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.map((activity) => {
                                                    const subActivities = activity.sub_activity || [];
                                                    const rowSpan = subActivities.length;

                                                    return subActivities.map((sub, idx) => (
                                                        <tr key={`${activity.activity_id}-${sub.sub_activity_id}`}>
                                                            <td>{sub.display_order}</td>
                                                            {idx === 0 && (
                                                                <td rowSpan={rowSpan} style={{ verticalAlign: 'middle' }}>
                                                                    {activity.activity_name}
                                                                </td>
                                                            )}
                                                            <td>{rowSpan != 1 ? sub.sub_activity_name : '-'}</td>

                                                            {idx === 0 && (
                                                                <td rowSpan={rowSpan} style={{ verticalAlign: 'middle' }}>
                                                                    <div className="d-flex justify-content-center gap-2">
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                                            <button className="btn-action edit" onClick={() => handleEdit(activity)}><FaEdit /></button>
                                                                        </OverlayTrigger>
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                                                                            <button className="btn-action delete" onClick={() => handleDelete(activity)}><FaTrashAlt /></button>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ));
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit Activity' : 'Add New Activity'}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Activity Name</label>
                                <input
                                    type='text'
                                    id="activityName"
                                    name="activityName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.activityName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.activityName && touched.activityName && (
                                    <p className="errormsg">{errors.activityName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="form-group">
                                <label className="form-label">Activity Display Order</label>
                                <input
                                    type='text'
                                    id="activityDisplayOrder"
                                    name="activityDisplayOrder"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.activityDisplayOrder}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.activityDisplayOrder && touched.activityDisplayOrder && (
                                    <p className="errormsg">{errors.activityDisplayOrder}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">is Sub Activity</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            name="activityIsSub"
                                            className="form-control"
                                            checked={values.activityIsSub === 1}
                                            onChange={(e) => setFieldValue('activityIsSub', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {values.activityIsSub == 0 &&
                        <Row>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Select Unit</label>
                                    <SelectFild
                                        Firstop='Select Unit'
                                        selectName='activityunit'
                                        options={[
                                            { name: 'Hours', id: 'Hours' },
                                            { name: 'Days', id: 'Days' },
                                            { name: 'Weeks', id: 'Weeks' },
                                        ]}
                                        value={values.activityunit}
                                        onChange={(selectedOption) => setFieldValue("activityunit", selectedOption?.value || "")}
                                        onBlur={handleBlur}
                                    />
                                    {errors.activityunit && touched.activityunit && (
                                        <p className="errormsg">{errors.activityunit}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Enter Unit Value</label>
                                    <input
                                        type='text'
                                        name="activityunitValue"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.activityunitValue}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.activityunitValue && touched.activityunitValue && (
                                        <p className="errormsg">{errors.activityunitValue}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Select Checklist</label>
                                    <SelectFild
                                        Firstop='Select Checklist'
                                        selectName='activitychecklist'
                                        options={commonMaster?.activity_purpose}
                                        value={values.activitychecklist}
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions ?
                                                Array.isArray(selectedOptions) ?
                                                    selectedOptions.map(option => option.value) :
                                                    selectedOptions.value :
                                                [];
                                            setFieldValue('activitychecklist', selectedValues);
                                        }}
                                        onBlur={() => handleBlur('activitychecklist')}
                                        isMulti={true}
                                    />
                                    {errors.activitychecklist && touched.activitychecklist && (
                                        <p className="errormsg">{errors.activitychecklist}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Select Output Email Template</label>
                                    <SelectFild
                                        Firstop='Select Output Template'
                                        selectName='activityoutputTemplateId'
                                        options={commonMaster?.email_template}
                                        value={values.activityoutputTemplateId}
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions ?
                                                Array.isArray(selectedOptions) ?
                                                    selectedOptions.map(option => option.value) :
                                                    selectedOptions.value :
                                                [];
                                            setFieldValue('activityoutputTemplateId', selectedValues);
                                        }}
                                        onBlur={() => handleBlur('activityoutputTemplateId')}
                                        isMulti={true}
                                    />
                                    {errors.activityoutputTemplateId && touched.activityoutputTemplateId && (
                                        <p className="errormsg">{errors.activityoutputTemplateId}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Select Client Centric Role</label>
                                    <SelectFild
                                        Firstop='Select Client Centric Role'
                                        selectName='clientCentricIds'
                                        options={commonMaster?.client_centric}
                                        value={values.clientCentricIds}
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions ?
                                                Array.isArray(selectedOptions) ?
                                                    selectedOptions.map(option => option.value) :
                                                    selectedOptions.value :
                                                [];
                                            setFieldValue('clientCentricIds', selectedValues);
                                        }}
                                        onBlur={() => handleBlur('clientCentricIds')}
                                        isMulti={true}
                                    />
                                    {errors.clientCentricIds && touched.clientCentricIds && (
                                        <p className="errormsg">{errors.clientCentricIds}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Select Billing Entity Centric Role</label>
                                    <SelectFild
                                        Firstop='Select Billing Entity Centric Role'
                                        selectName='billingEntityCentricIds'
                                        options={commonMaster?.billing_entity_centric}
                                        value={values.billingEntityCentricIds}
                                        onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions ?
                                                Array.isArray(selectedOptions) ?
                                                    selectedOptions.map(option => option.value) :
                                                    selectedOptions.value :
                                                [];
                                            setFieldValue('billingEntityCentricIds', selectedValues);
                                        }}
                                        onBlur={() => handleBlur('billingEntityCentricIds')}
                                        isMulti={true}
                                    />
                                    {errors.billingEntityCentricIds && touched.billingEntityCentricIds && (
                                        <p className="errormsg">{errors.billingEntityCentricIds}</p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    }

                    {values.activityIsSub == 1 && <>
                        {values.subActivity.map((subActivity, index) => (
                            <div key={index} className="fieldsets mainFS">
                                <div className='fieldsetsboxs'>
                                    <h6>Sub {index + 1}</h6>
                                    <div className="addreovebtns">
                                        <button type="button" className="btn add-btn" onClick={add}>+</button>
                                        {values.subActivity.length > 1 && (
                                            <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                        )}
                                    </div>
                                </div>
                                <div className='formsBox'>
                                    <Row>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Sub Activity Name</label>
                                                <input type="text"
                                                    name="name"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={subActivity.name}
                                                    onChange={(e) => setFieldValue(`subActivity[${index}].name`, e.target.value)}
                                                />
                                                {errors?.subActivity?.[index]?.name && touched?.subActivity?.[index]?.name && (
                                                    <p className="errormsg">{errors.subActivity[index].name}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Sub Display Order</label>
                                                <input
                                                    type="text"
                                                    name="displayOrder"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={subActivity.displayOrder}
                                                    onChange={(e) => setFieldValue(`subActivity[${index}].displayOrder`, e.target.value)}
                                                />
                                                {errors?.subActivity?.[index]?.displayOrder && touched?.subActivity?.[index]?.displayOrder && (
                                                    <p className="errormsg">{errors.subActivity[index].displayOrder}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Select Unit</label>
                                                <SelectFild
                                                    Firstop='Select Unit'
                                                    selectName={`subActivity[${index}].unit`}
                                                    options={[
                                                        { name: 'Hours', id: 'Hours' },
                                                        { name: 'Days', id: 'Days' },
                                                        { name: 'Weeks', id: 'Weeks' },
                                                    ]}
                                                    value={subActivity.unit}
                                                    onChange={(selectedOption) => setFieldValue(`subActivity[${index}].unit`, selectedOption?.value || "")}
                                                    onBlur={() => handleBlur(`subActivity[${index}].roleBy`)}
                                                />
                                                {errors.subActivity && errors.subActivity[index]?.unit && touched.unit && touched.subActivity[index]?.unit && (
                                                    <p className="errormsg">{errors.subActivity[index].unit}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Enter Unit Value</label>
                                                <input
                                                    type="text"
                                                    name="unitValue"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={subActivity.unitValue}
                                                    onChange={(e) => setFieldValue(`subActivity[${index}].unitValue`, e.target.value)}
                                                />
                                                {errors?.subActivity?.[index]?.unitValue && touched?.subActivity?.[index]?.unitValue && (
                                                    <p className="errormsg">{errors.subActivity[index].unitValue}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Select Checklist</label>
                                                <SelectFild
                                                    Firstop='Select Checklist'
                                                    selectName={`subActivity[${index}].checklist`}
                                                    options={commonMaster?.activity_purpose}
                                                    value={subActivity.checklist}
                                                    onChange={(selectedOptions) => {
                                                        const selectedValues = selectedOptions ?
                                                            Array.isArray(selectedOptions) ?
                                                                selectedOptions.map(option => option.value) :
                                                                selectedOptions.value :
                                                            [];
                                                        setFieldValue(`subActivity[${index}].checklist`, selectedValues);
                                                    }}
                                                    onBlur={() => handleBlur(`subActivity[${index}].checklist`)}
                                                    isMulti={true}
                                                />
                                                {errors.subActivity && errors.subActivity[index]?.checklist && touched.checklist && touched.subActivity[index]?.checklist && (
                                                    <p className="errormsg">{errors.subActivity[index].checklist}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Select Output Email Template</label>
                                                <SelectFild
                                                    Firstop='Select Output Template'
                                                    selectName='outputTemplateId'
                                                    options={commonMaster?.email_template}
                                                    value={subActivity.outputTemplateId}
                                                    onChange={(selectedOptions) => {
                                                        const selectedValues = selectedOptions ?
                                                            Array.isArray(selectedOptions) ?
                                                                selectedOptions.map(option => option.value) :
                                                                selectedOptions.value :
                                                            [];
                                                        setFieldValue(`subActivity[${index}].outputTemplateId`, selectedValues);
                                                    }}
                                                    onBlur={() => handleBlur(`subActivity[${index}].outputTemplateId`)}
                                                    isMulti={true}
                                                />
                                                {errors.subActivity && errors.subActivity[index]?.outputTemplateId && touched.outputTemplateId && touched.subActivity[index]?.outputTemplateId && (
                                                    <p className="errormsg">{errors.subActivity[index].outputTemplateId}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Select Client Centric Role</label>
                                                <SelectFild
                                                    Firstop='Select Client Centric Role'
                                                    selectName={`subActivity[${index}].clientRoleBy`}
                                                    options={commonMaster?.client_centric}
                                                    value={subActivity.clientRoleBy}
                                                    onChange={(selectedOptions) => {
                                                        const selectedValues = selectedOptions ?
                                                            Array.isArray(selectedOptions) ?
                                                                selectedOptions.map(option => option.value) :
                                                                selectedOptions.value :
                                                            [];
                                                        setFieldValue(`subActivity[${index}].clientRoleBy`, selectedValues);
                                                    }}
                                                    onBlur={() => handleBlur(`subActivity[${index}].clientRoleBy`)}
                                                    isMulti={true}
                                                />
                                                {errors.subActivity && errors.subActivity[index]?.clientRoleBy && touched.subActivity?.[index]?.clientRoleBy && (
                                                    <p className="errormsg">{errors.subActivity[index].clientRoleBy}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Select Billing Entity Centric Role</label>
                                                <SelectFild
                                                    Firstop='Select Billing Entity Centric Role'
                                                    selectName={`subActivity[${index}].billingRoleBy`}
                                                    options={commonMaster?.billing_entity_centric}
                                                    value={subActivity.billingRoleBy}
                                                    onChange={(selectedOptions) => {
                                                        const selectedValues = selectedOptions ?
                                                            Array.isArray(selectedOptions) ?
                                                                selectedOptions.map(option => option.value) :
                                                                selectedOptions.value :
                                                            [];
                                                        setFieldValue(`subActivity[${index}].billingRoleBy`, selectedValues);
                                                    }}
                                                    onBlur={() => handleBlur(`subActivity[${index}].billingRoleBy`)}
                                                    isMulti={true}
                                                />
                                                {errors.subActivity && errors.subActivity[index]?.billingRoleBy && touched.subActivity?.[index]?.billingRoleBy && (
                                                    <p className="errormsg">{errors.subActivity[index].billingRoleBy}</p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="form-group">
                                                <div className='d-flex align-items-center' style={{ marginTop: 10 }}>
                                                    <label className="form-label">Is Mandatory</label>
                                                    <div class="switchs" style={{ marginLeft: 10 }}>
                                                        <input
                                                            type="checkbox"
                                                            id={`subActivity[${index}].isMandatory`}
                                                            name={`subActivity[${index}].isMandatory`}
                                                            className="form-control"
                                                            autoComplete='off'
                                                            checked={subActivity.isMandatory === 1}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    `subActivity[${index}].isMandatory`,
                                                                    e.target.checked ? 1 : 0
                                                                );
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span class="slider round"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        ))}
                    </>
                    }
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{isEdit ? 'Update' : 'Save'}</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.activityName}</span> Activity?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}



            {/* <Col md={12}>
                <div className="form-group">
                    <label className="form-label">Default Attachment</label>
                    <ul className='attachmentsList'>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                        <li>
                            <div className='attBox'>
                                <div className="chkBox">
                                    <input type="checkbox" />
                                </div>
                                <div className="pdf-icon">
                                    <FaFilePdf size={16} color="#e74c3c" />
                                </div>
                                <p>Gratuity.pdf</p>
                                <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                            </div>
                        </li>
                    </ul>
                </div>
            </Col> */}
        </>
    )
}

export default Activity
